"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var range_1 = __importDefault(require("lodash/range"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_query_1 = require("react-query");
var api_1 = require("../../../api");
var callout_1 = require("../../../components/callout");
var error_message_1 = __importDefault(require("../../../components/error_message"));
var save_button_1 = require("../../../components/save_button");
var update_bundle_info_1 = require("../../../mutations/update-bundle-info");
var utils_1 = require("../../../utils");
var childOptions_1 = require("./childOptions");
exports.default = (function (_a) {
    var _b;
    var groupedSubscription = _a.groupedSubscription, bundleInfo = _a.bundleInfo, bundleType = _a.bundleType, customerId = _a.customerId, setIsLoading = _a.setIsLoading, setIsError = _a.setIsError;
    var queryClient = (0, react_query_1.useQueryClient)();
    var callout = (0, callout_1.useCallout)().callout;
    // Figure out how we're going to identify this bundle to the backend.
    // TODO: re-evaluate once migrated away from hb bundles
    var id;
    var idCol;
    if (groupedSubscription.manager === 'hellobello') {
        var bundleId = (_b = groupedSubscription.subscription.properties.find(function (obj) { return obj.name === 'bundle_id'; })) === null || _b === void 0 ? void 0 : _b.value;
        if (!bundleId)
            throw new Error('Cannot find bundle_id property for hellobello subscription');
        id = bundleId;
        idCol = 'bundleId';
    }
    else {
        id = "".concat(groupedSubscription.subscription.id);
        idCol = 'subscriptionId';
    }
    var shouldShowChildrenOptions = !(0, utils_1.isNonDiaperBundleType)(bundleType);
    var fieldContainerClassName = function (fieldName, extra) {
        return (0, classnames_1.default)(extra, 'margin-vertical-0', {
            'form-input': true,
            'with-error': errors && errors[fieldName],
            'is-filled': formValues && !!formValues[fieldName],
        });
    };
    var _c = (0, react_hook_form_1.useForm)({
        mode: 'all',
        defaultValues: {
            name: bundleInfo === null || bundleInfo === void 0 ? void 0 : bundleInfo.name,
            gender: bundleInfo === null || bundleInfo === void 0 ? void 0 : bundleInfo.gender,
            birthMonth: bundleInfo === null || bundleInfo === void 0 ? void 0 : bundleInfo.birthMonth,
            birthYear: bundleInfo === null || bundleInfo === void 0 ? void 0 : bundleInfo.birthYear,
        },
    }), register = _c.register, handleSubmit = _c.handleSubmit, watch = _c.watch, errors = _c.errors;
    var formValues = watch();
    var onAddChildSubmit = handleSubmit(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, mutateBundleInfo({
                        input: (_a = {},
                            _a[idCol] = id,
                            _a.customerId = customerId,
                            _a.name = data.name,
                            _a.gender = data.gender,
                            _a.birthMonth = Number(data.birthMonth),
                            _a.birthYear = data.birthYear ? Number(data.birthYear) : null,
                            _a),
                    })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); });
    var _d = (0, react_query_1.useMutation)('updateChildData', function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(update_bundle_info_1.UPDATE_BUNDLE_INFO, variables); }, {
        onSuccess: function () {
            setIsLoading(false);
            callout.success("Successfully Updated ".concat(shouldShowChildrenOptions ? 'Child' : 'Bundle', " Info!"));
            queryClient.invalidateQueries('getCustomerSubscriptions');
        },
    }), mutateBundleInfo = _d.mutateAsync, isLoading = _d.isLoading, error = _d.error, isError = _d.isError;
    (0, react_1.useEffect)(function () {
        setIsLoading(isLoading);
        setIsError(isError);
    }, [isLoading, isError]);
    // show the current year and the previous 15 years
    var currentYear = new Date().getFullYear();
    var birthYears = (0, range_1.default)(currentYear, currentYear - 15);
    return (react_1.default.createElement("div", { className: 'padding-vertical-3' },
        react_1.default.createElement("div", { className: 'margin-bottom-8' },
            react_1.default.createElement("div", { className: 'grid-x grid-padding-y' },
                react_1.default.createElement("div", { className: fieldContainerClassName('name', 'cell small-12') },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("input", { type: 'text', name: 'name', autoComplete: 'given-name', spellCheck: false, autoCapitalize: 'off', placeholder: 'First Name', ref: register({
                                required: {
                                    value: true,
                                    message: 'Required',
                                },
                            }) }),
                        react_1.default.createElement("span", { className: 'placeholder' }, "Whose bundle is it?")),
                    react_1.default.createElement(error_message_1.default, { error: errors.name })),
                shouldShowChildrenOptions && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: fieldContainerClassName('gender', 'cell small-12') },
                        react_1.default.createElement("label", null,
                            react_1.default.createElement("select", { name: 'gender', ref: register() }, childOptions_1.genderOptions.map(function (opt) { return (react_1.default.createElement("option", { key: opt.value, value: opt.value }, opt.text)); })),
                            react_1.default.createElement("span", { className: 'placeholder' }, "Gender")),
                        react_1.default.createElement(error_message_1.default, { error: errors.gender })),
                    react_1.default.createElement("div", { className: fieldContainerClassName('birthMonth', 'cell small-6') },
                        react_1.default.createElement("label", null,
                            react_1.default.createElement("select", { name: 'birthMonth', ref: register() }, childOptions_1.birthMonths.map(function (bm) { return (react_1.default.createElement("option", { key: bm.value, value: bm.value }, bm.text)); })),
                            react_1.default.createElement("span", { className: 'placeholder' }, "Birth Month")),
                        react_1.default.createElement(error_message_1.default, { error: errors.birthMonth })),
                    react_1.default.createElement("div", { className: fieldContainerClassName('birthYear', 'cell padding-left-3 small-6') },
                        react_1.default.createElement("label", null,
                            react_1.default.createElement("select", { name: 'birthYear', ref: register() },
                                react_1.default.createElement("option", null),
                                birthYears.map(function (y) { return (react_1.default.createElement("option", { key: y, value: y }, y)); })),
                            react_1.default.createElement("span", { className: 'placeholder' }, "Birth Year")),
                        react_1.default.createElement(error_message_1.default, { error: errors.birthYear })))),
                react_1.default.createElement("div", { className: 'cell small-12' },
                    react_1.default.createElement(save_button_1.SaveButton, { onClick: onAddChildSubmit, isLoading: isLoading }),
                    isError && react_1.default.createElement(error_message_1.default, { error: { message: error } }))))));
});
